function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import "./chunk-PXG64RU4.js";

// src/infiniteQueryBehavior.ts
import { addToEnd, addToStart, ensureQueryFn } from "./utils.js";
function infiniteQueryBehavior(pages) {
  return {
    onFetch: function onFetch(context, query) {
      var _a, _b, _c, _d, _e;
      var options = context.options;
      var direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
      var oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
      var oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
      var result = {
        pages: [],
        pageParams: []
      };
      var currentPage = 0;
      var fetchFn = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
          var cancelled, addSignalProperty, queryFn, fetchPage, previous, pageParamFn, oldData, param, remainingPages, _oldPageParams$, _param;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                cancelled = false;
                addSignalProperty = function addSignalProperty(object) {
                  Object.defineProperty(object, "signal", {
                    enumerable: true,
                    get: function get() {
                      if (context.signal.aborted) {
                        cancelled = true;
                      } else {
                        context.signal.addEventListener("abort", function () {
                          cancelled = true;
                        });
                      }
                      return context.signal;
                    }
                  });
                };
                queryFn = ensureQueryFn(context.options, context.fetchOptions);
                fetchPage = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data, param, previous) {
                    var createQueryFnContext, queryFnContext, page, maxPages, addTo;
                    return _regenerator().w(function (_context) {
                      while (1) switch (_context.n) {
                        case 0:
                          if (!cancelled) {
                            _context.n = 1;
                            break;
                          }
                          return _context.a(2, Promise.reject());
                        case 1:
                          if (!(param == null && data.pages.length)) {
                            _context.n = 2;
                            break;
                          }
                          return _context.a(2, Promise.resolve(data));
                        case 2:
                          createQueryFnContext = function createQueryFnContext() {
                            var queryFnContext2 = {
                              client: context.client,
                              queryKey: context.queryKey,
                              pageParam: param,
                              direction: previous ? "backward" : "forward",
                              meta: context.options.meta
                            };
                            addSignalProperty(queryFnContext2);
                            return queryFnContext2;
                          };
                          queryFnContext = createQueryFnContext();
                          _context.n = 3;
                          return queryFn(queryFnContext);
                        case 3:
                          page = _context.v;
                          maxPages = context.options.maxPages;
                          addTo = previous ? addToStart : addToEnd;
                          return _context.a(2, {
                            pages: addTo(data.pages, page, maxPages),
                            pageParams: addTo(data.pageParams, param, maxPages)
                          });
                      }
                    }, _callee);
                  }));
                  return function fetchPage(_x, _x2, _x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();
                if (!(direction && oldPages.length)) {
                  _context2.n = 2;
                  break;
                }
                previous = direction === "backward";
                pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                oldData = {
                  pages: oldPages,
                  pageParams: oldPageParams
                };
                param = pageParamFn(options, oldData);
                _context2.n = 1;
                return fetchPage(oldData, param, previous);
              case 1:
                result = _context2.v;
                _context2.n = 7;
                break;
              case 2:
                remainingPages = pages !== null && pages !== void 0 ? pages : oldPages.length;
              case 3:
                _param = currentPage === 0 ? (_oldPageParams$ = oldPageParams[0]) !== null && _oldPageParams$ !== void 0 ? _oldPageParams$ : options.initialPageParam : getNextPageParam(options, result);
                if (!(currentPage > 0 && _param == null)) {
                  _context2.n = 4;
                  break;
                }
                return _context2.a(3, 7);
              case 4:
                _context2.n = 5;
                return fetchPage(result, _param);
              case 5:
                result = _context2.v;
                currentPage++;
              case 6:
                if (currentPage < remainingPages) {
                  _context2.n = 3;
                  break;
                }
              case 7:
                return _context2.a(2, result);
            }
          }, _callee2);
        }));
        return function fetchFn() {
          return _ref.apply(this, arguments);
        };
      }();
      if (context.options.persister) {
        context.fetchFn = function () {
          var _a2, _b2;
          return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
            client: context.client,
            queryKey: context.queryKey,
            meta: context.options.meta,
            signal: context.signal
          }, query);
        };
      } else {
        context.fetchFn = fetchFn;
      }
    }
  };
}
function getNextPageParam(options, _ref3) {
  var pages = _ref3.pages,
    pageParams = _ref3.pageParams;
  var lastIndex = pages.length - 1;
  return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function getPreviousPageParam(options, _ref4) {
  var pages = _ref4.pages,
    pageParams = _ref4.pageParams;
  var _a;
  return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
  if (!data) return false;
  return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
  if (!data || !options.getPreviousPageParam) return false;
  return getPreviousPageParam(options, data) != null;
}
export { hasNextPage, hasPreviousPage, infiniteQueryBehavior };